export default {
	'.*2020_BMW_SUMMER_ON_SALES_EVENT.*': 'Summer Sales Event 2020',
	'.*SALES_EVENT.*': 'Sales Event',
	'.*BMW.*X5.*': 'BMW X5',
	'.*BMW.*X7.*': 'BMW X7',
	'.*BMW.*3.*SERIES.*': 'BMW 3 Series',
	'.*BMW_RECALLS.*': 'recall',
	'.*JOYOUS_SEASON.*': 'YEE 2019',
	'.*BMW2GRANCOUPE.*': '2 Series GC Conquest',
	'.*ADOPS_THE_ULTIMATE_BMWS_2.*': 'GKL+ Conquest',
	'.*ADOPS_2021_4SERIES_COUPE.*': '4 Series Conquest',
	'.*BMW_4_SERIES_COUPE.*': '2021 BMW 4 Series Coupe',
	'.*ROAD_HOME_2020.*': 'Road Home Sales Event 2020',
	'.*YEAR_END_EVENT.*': 'YEE 2019'
};
